import "@fontsource-variable/inter/opsz.css";
import "@/styles/globals.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/routes";
import { applyAccessibility } from "@/shell/accessibility";

// Baixa a fonte de leitura fácil se ela estiver escolhida (o `index.html`
// já pôs os atributos antes da primeira pintura).
applyAccessibility();

const container = document.getElementById("root");
if (!container) throw new Error('Elemento #root não encontrado no index.html');

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
